// extracted by mini-css-extract-plugin
module.exports = {"slider":"MainBanner_slider__C_cRF","mobile":"MainBanner_mobile__WG9dJ","desktop":"MainBanner_desktop__bNXu8"};